import { useCallback, useContext } from 'react'
import { useStore } from 'zustand'
import {
    ChatMessageState,
    createChatMessageStoreFactory,
} from './ChatMessageStore'
import { ChatMessageStoreContext } from './ChatMessageStoreProvider'

export const useChatMessageStore = <U>(
    selector: (state: ChatMessageState) => U
) => {
    const { chatInstanceId, chatMessageStores } = useContext(
        ChatMessageStoreContext
    )

    if (chatMessageStores === undefined) {
        throw new Error(
            '`chatMessageStores` is Missing. `useChatMessageStore` hook must be used within ChatMessageStoreProvider'
        )
    }

    const getOrCreateChatMessageStore = useCallback(
        () => createChatMessageStoreFactory(chatMessageStores),
        [chatMessageStores]
    )

    return useStore(getOrCreateChatMessageStore()(chatInstanceId), selector)
}
